import pRetry, { AbortError } from "p-retry";
import { authService } from "../services/authentication-service";
import { Log } from "../hooks/logger";

function getErrorMessage(responseBody) {
  try {
    const data = JSON.parse(responseBody);
    if (data.title) return data.title;
    else if (data.details) return data.details;
    else if (data.message) return data.message;
  } catch {
    // Not JSON
    return responseBody;
  }
}

export async function handleApiRequest(
  url,
  fetchOptions,
  options
) {
  // default parseBodyAsJson to true if not provided.
  // TODO: There must be a better way to do this.
  options = { parseBodyAsJson: true, noRetry: false, ...options };
  const auth = authService;

  let retryCount = 1;
  if (options.noRetry) retryCount = 0;

  return await pRetry(
    async () => {
      /*curl -X 'POST' \
          'https://localhost:7087/api/User/login' \
          -H 'accept: text/plain' \
          -H 'Content-Type: application/json' \
          -d '{
          "username": "string",
          "password": "string"
}'*/
      
      // 1) Contact the api
      const response = await fetch(url, fetchOptions);
      const text = await response.text();
      if (response.ok) {
        // 2) if ok, give the page back its data
        if (text && options?.parseBodyAsJson) {
          return JSON.parse(text);
        } else {
          return text;
        }
      } else {
        // 3) otherwise if the error wasn't Unauthorized or Forbidden abort
        if ([401, 403].indexOf(response.status) === -1) {
          const message = getErrorMessage(text) || text || response.statusText;

          // Show message box with the raw response text/message
          if (typeof window !== "undefined" && typeof window.alert === "function") {
            window.alert(message);
          }

          Log(`Api error: ${message}`, "error");
        }
        // 4) if token expired refresh login before retry
        if (
          response.headers.get("www-authenticate")?.includes("token expired")
        ) {
          Log("Api refresh triggered", "log");
          await auth.refreshLogin();
        } else {
          // 5) Not expired, so actually forbidden => logout
          auth.logout();
        }
        return Promise.reject();
      }
    },
    // 6) We only retry once (so 1 first attempt and 1 retry), if it failed again refreshing a second time won't help.
    { retries: retryCount }
  );
}
